import { NgModule } from '@angular/core';
import { LatestAutomationsComponent } from './latest-automations.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatListModule } from '@angular/material/list';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [LatestAutomationsComponent],
  exports: [LatestAutomationsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatListModule,
    GalaxyEmptyStateModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    MatTooltipModule,
  ],
})
export class LatestAutomationsModule {}
